import { deviceTypes } from '@styles/mediaQueries';
import styled, { css } from 'styled-components';

interface IContainer {
  disabled: boolean | undefined;
}

export const Container = styled.div<IContainer>`
  display: flex;
  cursor: pointer;
  opacity: ${({ disabled }) => (disabled ? '0.3' : '1')};
  margin-left: 32px;

  & + & {
    margin-top: 16px;
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  [data-device='${deviceTypes.mobile}'] & {
    flex-wrap: wrap;
    row-gap: 4px;
  }
`;

export const TagContainer = styled.div`
  display: flex;
  max-width: 205px;
  margin-right: 10px;
`;

interface IDescription {
  limitOfLines?: string;
}

export const Description = styled.div<IDescription>`
  display: flex;
  line-height: 22px;
  font-size: 14px;
  font-weight: 400;
  color: #696f8c;
  flex: 1;
  margin: 0 8px;

  ${({ limitOfLines }) =>
    !!limitOfLines &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: ${limitOfLines}; /* number of lines to show */
      line-clamp: ${limitOfLines};
      -webkit-box-orient: vertical;
    `};
`;

export const DateWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  gap: 4px;
`;

export const Date = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #8f95b2;
`;

export const IconDiv = styled.div`
  padding-top: 4px;
`;

export const NoDescription = styled.div`
  font-weight: 300;
  font-size: 14px;
  color: #8f95b2;
  font-style: italic;
  flex: 1;
  margin: 0 8px;
`;

export const DescriptionWrapper = styled.div`
  flex: 1;
  margin: 0 8px;
`;
